import { render, staticRenderFns } from "./ModalManage.vue?vue&type=template&id=a78166c4&scoped=true"
import script from "./ModalManage.vue?vue&type=script&lang=js"
export * from "./ModalManage.vue?vue&type=script&lang=js"
import style0 from "./ModalManage.vue?vue&type=style&index=0&id=a78166c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78166c4",
  null
  
)

export default component.exports